import Button from '@app-studio-web/ui/components/Button'
import InfoBox from '@app-studio-web/ui/components/InfoBox'
import Layout from '@app-studio-web/ui/components/Layout'
import useUpdateMode from '@hooks/useUpdateMode'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'inner_guide_name'
export default function InnerGuidePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState('')

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!inputValue.trim()) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Name your inner guide',
      answer_key: inputValue.toLowerCase(),
      answer: inputValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget, { method: 'post' })
    }
  }

  return (
    <Layout>
      <Form className="flex h-full flex-col" method="post" onSubmit={onSubmit}>
        <div className="mt-8">
          <h1 className="custom-heading text-center text-3xl whitespace-pre-line">
            {t('pages.onboarding.innerGuide.heading')}
          </h1>
        </div>

        <div className="flex flex-1 flex-col items-center justify-center gap-8">
          <div className="max-w-[500px] px-6 py-5 text-2xl">
            <p className="text-left text-xl">
              🧬 {t('pages.onboarding.innerGuide.description')}
            </p>
          </div>
          <InfoBox>{t('pages.onboarding.innerGuide.hint')}</InfoBox>

          <div className="w-full max-w-[500px]">
            <input
              data-testid="textfield"
              type="text"
              name="innerGuide"
              placeholder={t('pages.onboarding.innerGuide.placeholder')}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className="border-custom-gray w-full rounded-[20px] border bg-white px-7 py-6 text-center text-3xl placeholder:text-[#ACACAC]"
            />
          </div>
        </div>

        <div className="mx-auto mt-auto mb-8 flex w-full max-w-[500px] flex-col gap-4">
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue-input"
            disabled={!inputValue.trim()}
          />
        </div>
      </Form>
    </Layout>
  )
}
